import { PackageGeneralFormGzDataProvider } from '../dataProvider/PackageGeneralFormGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class PackageGeneralFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PackageGeneralFormGzDataProvider);
  }
}
